module.exports = __webpack_public_path__ + "static/media/2.1cc86fd8.jpg";